
function requestAPI(productId, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}product/${productId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionDetailProduct(productId) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'DETAIL_PRODUCT_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(productId, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'DETAIL_PRODUCT_SUCCESS',
        payload: result.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'DETAIL_PRODUCT_FAILURE',        
    error: error    
  })
}